import request from '@/utils/request.js';

//>创建帖子
export const CreatePosts = function(data) {
	return request.post("/post/add", data);
}

//>编辑帖子
export const EditPosts = function(data) {
	return request.post("/post/edit", data);
}

//>删除帖子
export const DeletePosts = function(data) {
	return request.post("/post/delete", data);
}

//>获取帖子详情
export const GetPostsByUUID = function(data) {
	return request.get("/post/get-by-uuid", data);
}

//>获取帖子列表
export const GetPostsList = function(data) {
	return request.get("/post/list", data);
}

//>获取帖子评论
export const GetPostsCommentList = function(data) {
	return request.get("/post/comments", data);
}

//>回复帖子
export const ReplyPosts = function(data){
	return request.post('/post/reply',data);
}

//>帖子点赞
export const PostsLike = function(data){
	return request.post('/post/zan',data);
}

//>帖子收藏
export const PostsCollect = function(data){
	return request.post('/post/collect',data);
}

//>关注用户
export const FollowUser = function(data){
	return request.post('/user/follow',data);
}

//>评论点赞
export const CommentLike = function(data){
	return request.post('/post/comment-zan',data);
}

//>评论删除
export const CommentDelete = function(data){
	return request.post('/post/delete-comment',data);
}

export const InfoCategory = function(data) {
	return request.get("/info/category", data);
}

export const InfoList = function(data) {
	return request.get("/info/list", data);
}

export const InfoHotList = function(data) {
	return request.get("/info/hot-list", data);
}

export const InfoRecommendList = function(data) {
	return request.get("/info/recommend-list", data);
}

export const InfoDetail = function(data) {
	return request.get("/info/get-by-uuid", data);
}


//>获取比赛列表
export const GetMatchList = function(data){
	return request.get('/match/list',data);
}

//>获取比赛详情
export const GetMatchDetail = function(data){
	return request.get('/match/detail',data);
}

//>获取参赛记录
export const GetMatchRecordList = function(data){
	return request.get('/match/match-join-log',data);
}

//>我的收藏列表
export const GetMyCollectList = function(data){
	return request.get('/user/collect-list',data);
}

//>我的帖子
export const GetMyPostList = function(data){
	return request.get('/user/post-list',data);
}
export const GetMyPostCount = function(data) {
	return request.get("/user/post-list-count", data);
}
//>获取我的关注列表
export const GetMyFollowList = function(data){
	return request.get('/user/follow-list',data);
}

export const GetMyFansList = function(data){
	return request.get('/user/fans-list',data);
}

export const CheckFollow = function(data){
	return request.get('/user/check-follow',data);
}

export const GetProfileList = function(data){
	return request.get('/user/profile-list',data);
}

//>大赛报名
export const MatchSignIn = function(data){
	return request.post('/match/sign-in',data);
}

//>大赛作品上传
export const MatchPostsUpload = function(data){
	return request.post('/match/posts-upload',data);
}

//>检查是否报名
export const MatchSignInCheck = function(data){
	return request.get('/match/check-signin',data);
}

//>大赛作品列表
export const MatchPostsList = function(data){
	return request.get('/match/posts-list',data);
}

//>获取话题列表
export const GetTopicListByKeyWord = function(data){
	return request.get('/post/topic-by-word',data);
}

//>创建话题
export const CreateTopic = function(data){
	return request.post('/post/create-topic',data);
}

//>大赛作品详情
export const GetMatchPostDetail = function(data){
	return request.get('/match/get-detail-by-uuid',data);
}


//>获取大赛作品评论
export const GetMatchPostsCommentList = function(data) {
	return request.get("/match/comments", data);
}

//>回复大赛作品
export const MatchReplyPosts = function(data){
	return request.post('/match/reply',data);
}

//>大赛作品点赞
export const MatchPostsLike = function(data){
	return request.post('/match/zan',data);
}

//>大赛作品收藏
export const MatchPostsCollect = function(data){
	return request.post('/match/collect',data);
}

//>大赛作品评论点赞
export const MatchPostsCommentLike = function(data){
	return request.post('/match/comment-zan',data);
}

//>大赛作品评论删除
export const MatchPostsCommentDelete = function(data){
	return request.post('/match/delete-comment',data);
}

// 大赛排行榜-列表
export const GetMatchVoteRankingList = function(data){
	return request.get('/match/rank-list',data);
}
// 大赛排行榜-投票详情
export const GetMatchVoteRankingRankDetai = function(data){
	return request.get('/match/rank-detail',data);
}
// 大赛排行榜-我的排名
export const GetMatchVoteRankingMyRank = function(data){
	return request.get('/match/my-rank',data);
}
export const GetCommitment = function(data){
	return request.get('/match/getCommitment',data);
}

export const GetGroupList = function(data){
	return request.get('/user/group-list',data);
}

export const CreateGroup = function(data){
	return request.post('/user/group-add',data);
}

export const EditGroup = function(data){
	return request.post('/user/group-edit',data);
}

export const DeleteGroup = function(data){
	return request.post('/user/group-delete',data);
}

export const SetUserGroup = function(data){
	return request.post('/user/group-user-set',data);
}

export const SubmitAppeal = function(data){
	return request.post('/appeal-submit',data);
}

export const SubmitCooperation = function(data){
	return request.post('/business-cooperation-submit',data);
}

export const SetPostPermission = function(data){
	return request.post('/post/set-permission',data);
}

export const submitReport = function(data){
	return request.post('/post/submit-report',data);
}

export const GetInviteList = function(data){
	console.log("invite-data",data);
	return request.get('/user/invite-list',data);
}



//大赛样衣申请
export const ApplyMatchSample = (data)=>{
	return request.post('/match/sample-apply',data);
}
export const CheckApplyMatchSample = (data)=>{
	return request.post('/match/sample-check',data);
}


export const editFansRemark = function(data){
	return request.post('/user/edit-fans-remark',data);
}